<template>
  <transition :name="transitionName" v-if="isMobile">
    <keep-alive>
      <navigation>
        <router-view class="child-view"></router-view>
      </navigation>
    </keep-alive>
  </transition>
  <transition v-else>
    <keep-alive exclude="grading,gradeevaluation,sharedetail,stuDetail,repeatReport">
      <router-view></router-view>
    </keep-alive>
  </transition>
</template>

<script type="text/ecmascript-6">
  import { getPlatform } from './../utils/platform'

  export default {
    data () {
      return {
        transitionName: '',
        isMobile: false
      }
    },
    created () {
      this.isMobile = getPlatform().isMobile
//      this.isMobile = platform
      if (this.isMobile) {
//        this.transitionName = ''
        this.$navigation.on('forward', (to, from) => {
          if (from && from.route.path && from.route.path === '/') {
            this.transitionName = ''
          } else {
            this.transitionName = 'slide-left'
          }
        })
        this.$navigation.on('back', (to, from) => {
          this.transitionName = 'slide-right'
        })
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">

  .child-view
    /*position: absolute*/
    width: 100%
    transition: all 0.4s

  .slide-left-enter, .slide-right-leave-active
    transform: translate3d(100%, 0, 0)

  .slide-left-leave-active, .slide-right-enter
    transform: translate3d(-100%, 0, 0)

  .slide-right-leave-active, slide-left-leave-active
    transition: all 0.4s ease
</style>



// WEBPACK FOOTER //
// src/common/components/u-view.vue